<!-- For brackets getting removed in click condition -->
<!-- prettier-ignore -->
@for (attribute of attributesMap | keyvalue:asIs; track attribute; let i = $index) {
<!-- Switch for type of attribute -->
@switch (attribute.key) { @case (AttributeType.Color) {
<div class="color-variations">
    <label>Choose Color </label>

    <ul class="variation-list">
        @for (colorVariant of attribute.value | keyvalue:alphabetAndNumberAscOrder; track colorVariant)
        {
        <li class="variation-content">
            <span (click)="goToProduct(attribute.key, colorVariant?.key)" class="variation-list-item product-color" [class.active]="attributeSelections.get(attribute.key)?.value === colorVariant?.key">
                @if (colorVariant?.value?.featured_images?.[0]) {
                <img [src]="colorVariant?.value?.featured_images?.[0]?.url" [title]="colorVariant?.key" [alt]="colorVariant?.key" class="variation-image" />
                } @else {
                {{ colorVariant?.key }}
                }

                <!-- unavailable for cart -->
                <!-- <span class="unavailable-cart">
                <img src="https://assets.hyperinvento.com/www_imaginext_com/assets/imaginext-assets/images/shopping-cart-icon-white.svg" class="unavailable-cart-icon" />
              </span> -->
            </span>
        </li>
        }
    </ul>
</div>
} @case (AttributeType.Size) { @if (attribute.value | keyvalue:keyAscOrder; as sizeVariants) { @if
(sizeVariants?.[0]?.key && (sizeVariants?.[0]?.key?.length ?? 0) <= 7) { <div class="size-variations">
    <label>Select Size</label>
    <ul class="variation-list">
        @for (sizeVariant of attribute.value | keyvalue:keyAscOrder; track sizeVariant) {
        <li [class.variation-active]="attributeSelections.get(attribute.key)?.value === sizeVariant?.key" (click)="goToProduct(attribute.key, sizeVariant?.key)" class="variation-content" [class.size-variants]="attribute.key === AttributeType.Size">
            <span class="strike"> </span>
            <p class="size-element" [title]="sizeVariant?.key">
                {{ sizeVariant?.key }}
            </p>
        </li>
        }
    </ul>
    </div>
    } @else {
    <div class="default-variation-section">
        <label>{{ attribute.key }}</label>
        <ul class="default-variation-list">
            @for (variant of attribute.value | keyvalue:alphabetAndNumberAscOrder; track variant) {
            <li class="variation-content">
                <div class="variation-list-item" (click)="goToProduct(attribute.key, variant?.key)" [class.active]="attributeSelections.get(attribute.key)?.value === variant?.key">
                    {{ variant?.key }}
                    <span class="strike"> </span>
                </div>
            </li>
            }
        </ul>
    </div>
    } } } @case (AttributeType.SizeCM) {
    <div class="size-variations">
        <label>Select Size(CM)</label>
        <ul class="variation-list">
            @for (sizeVariant of attribute.value | keyvalue:keyAscOrder; track sizeVariant) {
            <li [class.variation-active]="attributeSelections.get(attribute.key)?.value === sizeVariant?.key" (click)="goToProduct(attribute.key, sizeVariant?.key)" class="variation-content">
                <span class="strike"> </span>
                <p class="size-element" [title]="sizeVariant?.key">
                    {{ sizeVariant?.key }}
                </p>
            </li>
            }
        </ul>
    </div>
    } @case (AttributeType.SizeUS) {
    <div class="size-variations">
        <label>Select Size(US)</label>
        <ul class="variation-list">
            @for (sizeVariant of attribute.value | keyvalue:keyAscOrder; track sizeVariant) {
            <li [class.variation-active]="attributeSelections.get(attribute.key)?.value === sizeVariant?.key" (click)="goToProduct(attribute.key, sizeVariant?.key)" class="variation-content">
                <span class="strike"> </span>
                <p class="size-element" [title]="sizeVariant?.key">
                    {{ sizeVariant?.key }}
                </p>
            </li>
            }
        </ul>
    </div>
    } @case (AttributeType.SizeUK) {
    <div class="size-variations">
        <label>Select Size(UK)</label>
        <ul class="variation-list">
            @for (sizeVariant of attribute.value | keyvalue:keyAscOrder; track sizeVariant) {
            <li [class.variation-active]="attributeSelections.get(attribute.key)?.value === sizeVariant?.key" (click)="goToProduct(attribute.key, sizeVariant?.key)" class="variation-content">
                <span class="strike"> </span>
                <p class="size-element" [title]="sizeVariant?.key">
                    {{ sizeVariant?.key }}
                </p>
            </li>
            }
        </ul>
    </div>
    } @case (AttributeType.ApparelSize) {
    <div class="size-variations">
        <label>Select Size</label>
        <ul class="variation-list">
            @for (sizeVariant of attribute.value | keyvalue:apparelSize; track sizeVariant) {
            <li [class.variation-active]="attributeSelections.get(attribute.key)?.value === sizeVariant?.key" (click)="goToProduct(attribute.key, sizeVariant?.key)" class="variation-content">
                <span class="strike"> </span>
                <p class="size-element" [title]="sizeVariant?.key">
                    {{ sizeVariant?.key }}
                </p>
            </li>
            }
        </ul>
    </div>
    } @default {
    <div class="default-variation-section">
        <label>{{ attribute.key }}</label>
        <ul class="default-variation-list">
            @for (variant of attribute.value | keyvalue:alphabetAndNumberAscOrder; track variant) {
            <li class="variation-content">
                <div class="variation-list-item" (click)="goToProduct(attribute.key, variant?.key)" [class.active]="attributeSelections.get(attribute.key)?.value === variant?.key">
                    {{ variant?.key }}
                    <span class="strike"> </span>
                </div>
            </li>
            }
        </ul>
    </div>
    } } }